import {z} from 'zod'

export const ViewEntity = z.enum([
    'users',
    'patients',
    'treatmentRequestsAll',
    'treatmentRequestsWaitingList',
    'treatmentRequestsInProgress',
    'treatmentRequestsAccepted',
    'treatmentRequestsRejected',
    'treatmentRequestsInReview',
    'projects',
    'accesses'
])
export type ViewEntity = z.infer<typeof ViewEntity>

export const View = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    body: z.string().min(1),
    visibility: z.enum(['public', 'private'])
})

export type View = z.infer<typeof View>
